
import Button from "@/components/base/Button"
import Oabot from "@/components/oabot/Oabot"
import { mdiChevronLeft } from "@mdi/js"

export default {
    name: "OabotCard",
    components: { Button, Oabot },
    props: {
        /** if "< zurück" button is shown */
        showBackBtn: {
            type: Boolean,
            default: false,
        },
    },
    data: function () {
        return {
            mdiChevronLeft,
            oabotEmotion: ["happy", "neutral", "thinking"],
        }
    },

    methods: {},
}
